/**
 * Leaflet divIcon builders for the dashboard site maps.
 *
 * Site markers render as small colored dots/squares on the map surfaces; the
 * HTML strings are plain divIcon markup (CSS vars resolve fine here since it's
 * real DOM, not a canvas/data-URI context).
 *
 * Contains:
 * - createCircleIcon  — round marker for analog sites
 * - createDigitalIcon — squared-off marker for digital sites
 */

import L from 'leaflet';

const MARKER_SIZE = 14;
const MARKER_BORDER = '2px solid white';
const MARKER_SHADOW = '0 1px 3px rgba(0,0,0,0.3)';

/**
 * @param {string} color
 * @returns {L.DivIcon}
 */
export function createCircleIcon(color) {
  return L.divIcon({
    className: 'dashboard-map-marker',
    html: `<div style="
      width: ${MARKER_SIZE}px;
      height: ${MARKER_SIZE}px;
      border-radius: 50%;
      background: ${color};
      border: ${MARKER_BORDER};
      box-shadow: ${MARKER_SHADOW};
    "></div>`,
    iconSize: [MARKER_SIZE, MARKER_SIZE],
    iconAnchor: [MARKER_SIZE / 2, MARKER_SIZE / 2],
  });
}

/**
 * @param {string} color
 * @returns {L.DivIcon}
 */
export function createDigitalIcon(color) {
  return L.divIcon({
    className: 'dashboard-map-marker',
    html: `<div style="
      width: ${MARKER_SIZE}px;
      height: ${MARKER_SIZE}px;
      border-radius: 2px;
      background: ${color};
      border: ${MARKER_BORDER};
      box-shadow: ${MARKER_SHADOW};
    "></div>`,
    iconSize: [MARKER_SIZE, MARKER_SIZE],
    iconAnchor: [MARKER_SIZE / 2, MARKER_SIZE / 2],
  });
}
